import { render, staticRenderFns } from "./CustomCategoryPage.vue?vue&type=template&id=aec91ea4&scoped=true&"
import script from "./CustomCategoryPage.vue?vue&type=script&lang=js&"
export * from "./CustomCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomCategoryPage.vue?vue&type=style&index=0&id=aec91ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec91ea4",
  null
  
)

export default component.exports